import { Box } from "@chakra-ui/layout";
import { Link, HStack, Spacer } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation("common");
  const isFrench = i18n.language?.toLowerCase().startsWith("fr");

  return (
    <HStack bg="brand.darkblue" px="10" py="4" marginTop="auto">
      <Box color="white">{t("footer.copyright")}</Box>
      <Spacer />
      <HStack spacing={"50px"}>
        {!isFrench ? (
          <>
            <Link color="white" as={RouterLink} to="/termsofuse" isExternal>
              {t("Terms of Use")}
            </Link>
            <Link color="white" target="_blank" href="https://www.moneris.com/en/legal/privacy-notice">
              {t("Privacy Statement")}
            </Link>
          </>
        ) : (
          <>
            <Link color="white" target="_blank" href="https://www.moneris.com/fr-ca/juridiques/conditions-utilisation">
              {t("Terms of Use")}
            </Link>
            <Link color="white" target="_blank" href="https://www.moneris.com/fr-ca/juridiques/enonce-sur-la-protection-des-renseignements-personnels">
              {t("Privacy Statement")}
            </Link>
          </>
        )
        }
      </HStack>
    </HStack>
  );
};

export default Footer;
